@if (suggestions?.[0]) {
  <div
    class="fst-italic text-gray-600 suggestion">
    Did you mean
    <a
      role="button"
      class="btn-link text-lightblue-400"
      tabindex="0"
      (keyup.enter)="container.setParams({query: suggestions[0].text})"
      (click)="container.setParams({query: suggestions[0].text})"
      [innerHTML]="suggestions[0].highlight || suggestions[0].text"></a>
  </div>
}
